import { Fragment } from 'react';

import { useHasCaptureAccess } from '~/hooks/account';
import { segmentTypes } from '~/lib/segments';

import AddCapturePlan from './AddPlan/AddCapturePlan';
import AddPlanSection from './AddPlan/AddPlanSection';
import destinationGroups from './destinationsConfigurations';
import PlanDestinationGroup from './PlanDestinationGroup';
import useAvailableDestinationsLegacy from './useAvailableDestinationsLegacy';

export default function LegacyPlanDestinations({
  userContainer,
  segment,
  account,
}) {
  const showAlerting = userContainer.shouldShowDestinationGroup('alerting');
  const showAdsProducts = userContainer.shouldShowDestinationGroup('ads');
  const showCapture = useHasCaptureAccess();
  const showPersonalization = userContainer.shouldShowDestinationGroup(
    'personalization',
  );

  const isCompany = segment.type === segmentTypes.company;

  const enabledDestinations = useAvailableDestinationsLegacy(
    segment.type,
    account,
    showAlerting,
    showAdsProducts,
    showPersonalization,
  );

  const marketingPanels = {
    capture: {
      show: isCompany && !showCapture,
      panel: (
        <div className="mb-4">
          <AddCapturePlan segment={segment} />
        </div>
      ),
    },

    alerting: {
      show: !showAlerting,
      panel: (
        <AddPlanSection
          title="Alerting"
          user={userContainer}
          segment={segment}
        />
      ),
    },
    advertising: {
      show: !showAdsProducts,
      panel: (
        <AddPlanSection
          title="Advertising"
          user={userContainer}
          segment={segment}
        />
      ),
    },
    personalization: {
      show: isCompany && !showPersonalization,
      panel: (
        <AddPlanSection
          title="Personalization"
          user={userContainer}
          segment={segment}
        />
      ),
    },
  };

  return (
    <>
      {destinationGroups.map((group) => (
        <Fragment key={group.key}>
          <PlanDestinationGroup
            key={group.title}
            segment={segment}
            title={group.title}
            description={group.description}
            audiences={!!group.audiences}
            items={group.items}
            enabled={enabledDestinations}
          />

          {marketingPanels[group.key]?.show
            ? marketingPanels[group.key].panel
            : null}
        </Fragment>
      ))}
    </>
  );
}
